import { CommonModule } from '@angular/common';
import {
  Component, EventEmitter, Input, Output
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { IrisButtonModule, IrisCardModule } from '@sondermindorg/iris-design-system-angular';
import { IRequestSessionParams } from '../../models/request-session-params.interface';

@Component({
  selector: 'connect-card',
  standalone: true,
  imports: [
    CommonModule,
    IrisButtonModule,
    IrisCardModule,
    RouterModule
  ],
  templateUrl: './connect-card.component.html',
  styleUrls: ['./connect-card.component.scss']
})
export class ConnectCardComponent {
  @Input() ctaButtonText: string = 'Get started';
  @Input() firstName: string = 'this provider';
  @Input() paramsShareCode: string = '';
  @Input() paramsName: string = '';
  @Input() requestSessionQueryParams: IRequestSessionParams = null; // For tracking the user coming from .com site
  @Input() soonestAvailableDate: Date | null = null;
  @Input() useCheckoutFormFf: boolean;
  @Output() requestASessionClicked: EventEmitter<boolean> = new EventEmitter<boolean>();

  onCtaClicked(isLinkToFlow: boolean): void {
    this.requestASessionClicked.emit(isLinkToFlow);
  }
}
